import { Box, Paper, styled, Typography } from '@mui/material';
import {
  DataGrid,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
} from '@mui/x-data-grid';

type StageData = {
  id: string;
  blockName: string;
  stageName: string;
  count: number;
  order: number;
};

type Props = {
  blockName: string;
  stages: StageData[];
};

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <Box sx={{ flexGrow: 1 }} />
      <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
    </GridToolbarContainer>
  );
}

export const RawCountsBlockTable = ({ blockName, stages }: Props) => {
  const columns: GridColDef[] = [
    {
      field: 'blockName',
      headerName: 'Block Name',
      flex: 1,
      sortComparator: (v1: string, v2: string) =>
        v1.localeCompare(v2, undefined, { numeric: true, sensitivity: 'base' }),
    },
    {
      field: 'stageName',
      headerName: 'Stage Name',
      sortComparator: (_v1, _v2, param1, param2) => {
        const rowA = param1.api.getRow(param1.id);
        const rowB = param2.api.getRow(param2.id);
        return (rowA?.order || 999) - (rowB?.order || 999);
      },
      flex: 2,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'count',
      headerName: 'Count',
      type: 'number',
      minWidth: 150,
      align: 'center',
      headerAlign: 'center',
    },
  ];

  return (
    <StyledContainer
      sx={{
        display: 'flex',
        flexDirection: 'column',
        // width: '80%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 4,
      }}
    >
      <Typography
        variant='subtitle1'
        sx={{
          padding: 2,
          fontWeight: 600,
          textAlign: 'left',
        }}
      >
        {blockName}
      </Typography>
      <DataGrid
        rows={stages}
        columns={columns}
        slots={{ toolbar: CustomToolbar }}
        disableRowSelectionOnClick
      />
    </StyledContainer>
  );
};

const StyledContainer = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.vars.palette.background.default,
}));
